import React from 'react';
import {Api} from "../app-controller.js";
import {Panel, PanelBody} from "../components/panel/panel.jsx";

class Notifications extends React.Component {
    constructor(props) {
        super(props);

        this.state = {}

    }

    componentDidMount() {

        /*let searchUser={
            target: "#busqueda",
            elementClass: "form-control",
            elements: [
                {
                    input:{
                        cols:4,
                        name:"asunto",
                        type: "text",
                        label:"Asunto"
                    }
                }, {
                    input:{
                        cols: 4,
                        name:"contenido",
                        type: "text",
                        label:"Mensaje"
                    }
                }, {
                    input:{
                        cols:4,
                        name:"fecha",
                        type: "date",
                        label:"Fecha"
                    }
                }  
            ],
            onchange : (me,data,serial)=>{
                gridUsuarios.go(1,serial);
            }        
        };*/

        //let buscadorUsuarios = Api.form(searchUser);

        let gridUsuarios = Api.grid({
            source: "app/getInbox",
            target: "#gridNotificaciones",
            params:{grid:1},
            tableClass: "table table-striped m-b-0 table-hover",
            rowsPerPage: [
                5, 10, 25, 50, 100
            ],
            progressText: "Cargando notificaciones",
            rows: {
                id:{
                    label:"ID"
                },
                asunto: {
                    label: "Asunto",
                },
                contenido: {
                    label: "Mensaje"
                },
                fecha: {
                    label: "Fecha"
                }

            }
        })



    //Termina did mount
    }

    render() {
        return (
            <div className="row">
                <Panel className="col-sm-12">
                    <PanelBody>
                        <fieldset className="col-sm-12">
                            <legend>Buscar notificaciones </legend>
                            <div id="busqueda"></div>
                            <hr/>
                            <div id="gridNotificaciones"></div>
                        </fieldset>
                    </PanelBody>
                </Panel>

            </div>
        )
    }
};

export default Notifications;